var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"axis-badge",class:'axis-badge--' + _vm.state},[_vm._v(_vm._s(_vm.axis))])
}
var staticRenderFns = []

export { render, staticRenderFns }